import React, { useState, useCallback, useContext } from 'react'

const INITIAL_STATE = {
  open: false,
  message: ''
}

const ErrorSnackBarContext = React.createContext(INITIAL_STATE)

function ErrorModalProvider({ children }) {
  const [errorSnackBarState, setErrorSnackBarState] = useState(INITIAL_STATE)

  const setOpen = useCallback(
    (open = false, message = '', type = 'error', duration = 7000) => {
      setErrorSnackBarState(state => (
        {
          ...state,
          open,
          message,
          type,
          duration
        }))
    },
    []
  )

  return <ErrorSnackBarContext.Provider
    value={{ errorSnackBarState, errorSnackBarActions: { setOpen } }}>{children}</ErrorSnackBarContext.Provider>
}

export function useErrorSnackBarContext() {
  const { errorSnackBarState, errorSnackBarActions } = useContext(ErrorSnackBarContext)
  return { errorSnackBarState, errorSnackBarActions }
}

export default ErrorModalProvider
